import { formatDistance } from 'date-fns/formatDistance';
import { enUS } from 'date-fns/locale/en-US';

function getLocale() {
  return enUS;
}

export function getJSDateFromDateString(dateString: string): Date {
  // ie. 2024-02-04
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const dateTime = new Date(dateString).getTime();
    const timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    return new Date(dateTime + timezoneOffset);
  } else {
    return new Date(dateString);
  }
}

export function formatJsDateToRelativeDate(date: Date | string): string {
  let dateImpl: Date;
  if (typeof date === 'string') {
    dateImpl = getJSDateFromDateString(date);
  } else {
    dateImpl = date;
  }
  const locale = getLocale();
  const result = formatDistance(dateImpl, new Date(), {
    locale,
    includeSeconds: false,
    addSuffix: true,
  });

  if (locale == enUS) {
    // shorten the output string if under a minute
    return result.replace(/(less than|about) /g, '');
  } else {
    return result;
  }
}
